import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutSection from './components/AboutSection';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ComparisonSection from './components/ComparisonSection';
import CategoryGrid from './components/CategoryGrid';
import BlogSection from './components/BlogSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.boats';

function HomeStructuredData() {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'HooBuy Boats',
    url: siteUrl,
    description: 'HoobuySpreadsheet 2026: A lista completa atualizada e guia definitivo de compras na China com produtos verificados e economia de até 60%.',
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: siteUrl,
    name: 'HoobuySpreadsheet 2026: Lista Completa Atualizada + Guia Definitivo de Compras na China | HooBuy Boats',
    description: 'HoobuySpreadsheet 2026: descubra a lista completa atualizada com os melhores produtos baratos da China. Guia definitivo de compras com comparações reais, produtos verificados e economia de até 60%.',
    inLanguage: 'pt',
    isPartOf: {
      '@type': 'WebSite',
      name: 'HooBuy Boats',
      url: siteUrl,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />
    </>
  );
}

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <HomeStructuredData />
      <Navbar />
      <main>
        <AboutSection />
        <HeroSection />
        <TrustSection />
        <ComparisonSection />
        <CategoryGrid />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
}